import React from "react";
import { useFieldArray } from "react-hook-form";
import { dateToString } from "~/utils/formatter";
import { useTranslation } from "react-i18next";

//Components
import Form, { Group } from "~/common/components/Form";
import Input from "~/common/components/Input";
import DatePicker from "~/common/components/DatePicker";
import NumberInput from "~/common/components/NumberInput";
import Select from "~/common/components/Select";

//Assets
import "~/assets/sass/pages/portfolio/portfolioEdit.scss";
import { PlusIcon } from "~/assets/svg/MathIcon";
import { QuestionMarkIcon, RoundMinusIcon } from "~/assets/svg/InterfaceIcon";
import { STEP_OPTIONS } from "../CommonEditView/index";

const StartupInvests = ({ useForm }) => {
	const {
		fields: startupInvestsFields,
		append: startupInvestsAppend,
		replace: startupInvestsReplace,
		remove: startupInvestsRemove,
	} = useFieldArray({
		control: useForm.control,
		name: "startupInvests",
	});
	const { t } = useTranslation();

	const handleAddStartupInvest = () => {
		startupInvestsAppend({
			name: "",
			step: "",
			value: "",
			comValue: "",
			date: dateToString(new Date(), "yyyy-MM-dd"),
		});
	};

	const handleRemoveStartupInvest = (index) => {
		if (startupInvestsFields.length <= 0) return;
		startupInvestsRemove(index);
	};

	return (
		<li className="detail-info-item invest-history">
			<div className="title-group">
				<h4 className="detail-info-title">
					{t("pages.portfolio.PortfolioEdit.components.StartupInvests.historyInvest")}
					<div className="c__tooltip-btn">
						<QuestionMarkIcon />
						<p className="c__tooltip">
							투자 받은 시점과 투자사 별로 투자 금액과 당시 벨류를 추가하여 기업의
							투자 히스토리를 만들 수 있습니다.
							<br />
							<br />
							<div className="bold">[진행 상태]</div>
							- 진행 중 : 투자가 진행 중인 상태입니다.
							<br />- 완료 : 투자가 완료된 상태입니다.
						</p>
					</div>
				</h4>
				<button
					type="button"
					className="dashed-btn plus-btn"
					onClick={handleAddStartupInvest}
				>
					<PlusIcon />
					{t("pages.portfolio.PortfolioEdit.components.StartupInvests.addInputs")}
				</button>
			</div>
			<div>
				<div className="c__table table-invest-history">
					<div className="thead">
						<div className="tr">
							<div className="th invest-date">
								{t(
									"pages.portfolio.PortfolioEdit.components.StartupInvests.investPoint"
								)}
							</div>
							<div className="th vc">
								{t(
									"pages.portfolio.PortfolioEdit.components.StartupInvests.companyName"
								)}
							</div>
							<div className="th invest-step">
								{t(
									"pages.portfolio.PortfolioEdit.components.StartupInvests.investStage"
								)}
							</div>
							<div className="th invest-price">
								{t(
									"pages.portfolio.PortfolioEdit.components.StartupInvests.investAmount"
								)}{" "}
								<span className="unit">
									{t(
										"pages.portfolio.PortfolioEdit.components.StartupInvests.unit"
									)}
								</span>
							</div>
							<div className="th invest-price">
								당시벨류
								<span className="unit">
									{t(
										"pages.portfolio.PortfolioEdit.components.StartupInvests.unit"
									)}
								</span>
							</div>
						</div>
					</div>
					<div className="tbody">
						{startupInvestsFields &&
							startupInvestsFields.map((startupInvest, index) => {
								return (
									<Form key={startupInvest.id} useForm={useForm} className="tr">
										<DatePicker
											name="investPointDateHistory"
											className="td invest-date"
											value={useForm.watch().startupInvests[index].date}
											{...useForm.register(`startupInvests.${index}.date`)}
										/>
										<Input
											name="vcNameHistory"
											className="td vc"
											placeholder={t(
												"pages.portfolio.PortfolioEdit.components.StartupInvests.investCompany"
											)}
											value={useForm.watch().startupInvests[index].name}
											{...useForm.register(`startupInvests.${index}.name`)}
										/>
										<Select
											name="purposeRoundHistory"
											options={STEP_OPTIONS}
											// defaultValue="PreSeed"
											className="td invest-step"
											defaultValue={
												useForm.watch().startupInvests[index].step
											}
											{...useForm.register(`startupInvests.${index}.step`)}
										/>
										<NumberInput
											name="investPriceHistory"
											placeholder={t(
												"pages.portfolio.PortfolioEdit.components.StartupInvests.investAmount"
											)}
											value={useForm.watch().startupInvests[index].value}
											{...useForm.register(`startupInvests.${index}.value`)}
											decimalScale={2}
											fixedDecimalScale={false}
											className="td invest-price"
										/>
										<Group className="td invest-price">
											<NumberInput
												name="investComValueHistory"
												placeholder={t(
													"pages.portfolio.PortfolioEdit.components.StartupInvests.investAmount"
												)}
												value={
													useForm.watch().startupInvests[index].comValue
												}
												{...useForm.register(
													`startupInvests.${index}.comValue`
												)}
												decimalScale={2}
												fixedDecimalScale={false}
											/>
											<button
												type="button"
												className="btn-round-delete"
												onClick={() => {
													handleRemoveStartupInvest(index);
												}}
											>
												<RoundMinusIcon />
											</button>
										</Group>
									</Form>
								);
							})}
					</div>
				</div>
			</div>
		</li>
	);
};

export default StartupInvests;
